import React from 'react'
import { FormControl, InputLabel, Select, MenuItem, SelectProps } from '@material-ui/core'

export interface ISelectItemType {
  value: string | number
  label: string
}

export interface ISelectProps extends SelectProps {
  options: ISelectItemType[]
  withEmptyValue?: boolean
}

export const SelectField: React.FC<ISelectProps> = ({ options, withEmptyValue, ...selectProps }) => {
  return (
    <FormControl fullWidth>
      <InputLabel>{selectProps.label}</InputLabel>
      <Select defaultValue={''} {...selectProps}>
        {withEmptyValue && (
          <MenuItem value={''}>
            <em>Не выбрано</em>
          </MenuItem>
        )}
        {options.map(({ value, label }) => (
          <MenuItem key={`sel-${value}`} value={`${value}`}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
